<section class="table-page table-page--compact table-page--dense modalidad-form-modal">
  <header class="modalidad-form-modal__header">
    <h2>{{ titulo }}</h2>
    <p>{{ persona }}</p>
  </header>

  <div class="modalidad-form-modal__body">
    <div class="modalidad-form-modal__grid">
      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Modalidad</mat-label>
        <mat-select [(ngModel)]="modalidad.modalidad" (selectionChange)="alCambiarModalidad()">
          <mat-option value="OFICINA">En sitio</mat-option>
          <mat-option value="HOME_OFFICE">Desde casa</mat-option>
          <mat-option value="MIXTO">Mixto</mat-option>
        </mat-select>
        <mat-hint>Mixto significa que el lugar lo decide el patrón o el plan del día.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="necesitaSitio">
        <mat-label>Sitio donde se le espera</mat-label>
        <mat-select [(ngModel)]="modalidad.idUbicacionBase">
          <mat-option *ngFor="let sitio of sitiosElegibles" [value]="sitio.id">
            {{ sitio.nombre }}<span *ngIf="sitio.nombreCliente"> · {{ sitio.nombreCliente }}</span>
          </mat-option>
        </mat-select>
        <mat-hint>Sin sitio, la evaluación no sabe dónde debía estar.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Rige desde</mat-label>
        <input matInput aria-label="Rige desde" type="date" [(ngModel)]="modalidad.fechaInicioVigencia" />
        <mat-hint>Lo anterior se cierra el día previo; no se pisa.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Hasta (opcional)</mat-label>
        <input matInput aria-label="Hasta (opcional)" type="date" [(ngModel)]="modalidad.fechaFinVigencia" />
        <mat-hint>Vacío = sin fecha de término.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="!necesitaSitio">
        <mat-label>Zona horaria (opcional)</mat-label>
        <mat-select [(ngModel)]="modalidad.zonaHoraria">
          <mat-option [value]="null">La de la empresa</mat-option>
          <mat-option *ngFor="let zona of zonas" [value]="zona">{{ zona }}</mat-option>
        </mat-select>
        <mat-hint>Solo si trabaja desde casa en otro huso.</mat-hint>
      </mat-form-field>
    </div>

    <div class="modalidad-form-modal__patron" *ngIf="esMixto">
      <h3>Patrón semanal</h3>
      <p class="modalidad-form-modal__nota">
        Para cada día, dónde trabaja por la mañana y por la tarde. La excepción de un día suelto
        —«el martes me quedo en casa»— se declara en Mi plan y gana sobre esto.
      </p>
      <div class="modalidad-form-modal__dias">
        <div class="modalidad-form-modal__dia" *ngFor="let dia of patron; trackBy: porDia">
          <span class="modalidad-form-modal__dia-nombre">{{ dia.nombre }}</span>
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Mañana</mat-label>
            <mat-select [(ngModel)]="dia.manana" [aria-label]="dia.nombre + ', mañana'">
              <mat-option value="OFICINA">En sitio</mat-option>
              <mat-option value="HOME_OFFICE">Desde casa</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Tarde</mat-label>
            <mat-select [(ngModel)]="dia.tarde" [aria-label]="dia.nombre + ', tarde'">
              <mat-option value="OFICINA">En sitio</mat-option>
              <mat-option value="HOME_OFFICE">Desde casa</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <footer class="modalidad-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            [disabled]="guardando" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary app-form-btn--compact"
            [disabled]="guardando" (click)="guardar()">
      <span class="material-icons">save</span>
      {{ guardando ? "Guardando…" : "Guardar" }}
    </button>
  </footer>
</section>
